export const fieldInvalidIconPath = "svg/ico-error.svg";
